/**
 * サイト全体で使う設定値を管理するファイル
 */

import Vue from "vue";
import Vuex from "vuex";
import { Vector2, Clock } from "three";

import touch from "./touch";
import modal from "./modal";
import webgl from "./webgl";
import errorModal from "./errorModal";

import MiniMap from "@/webgl/common/MiniMap";
import RoomLabel from "@/webgl/common/RoomLabel";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    imgEx: "webp",

    id: null,
    category: null,
    resolution: new Vector2(),
    mouse: new Vector2(),
    clock: new Clock(),
    update: null,
    resize: null,

    madoriMode: "2d", // 2d or 3d
    nameOfRoom: "",
    miniMap: new MiniMap(),
    roomLabel: new RoomLabel(),
    currentNodeId: -1,
    testMode: "",

    // 0,1のステータス
    isMobile: false, // モバイルかどうか
    isLandscape: false, // モバイルの場合、デバイスの向きが縦か横
    isFullScreen: false, // フルスクリーンモードかどうか
    information: null,
    isGalleryDrawerMenu: false, // 物件メニューの表示・非表示
    isGalleryList: false, // 物件リストの表示・非表示
    isLoading: true, // ローディングの表示・非表示
    isCursorPointer: false, // マウスポインタのCursor状態の管理

    // APIから取得したデータを格納する
    rooms: {},
    photos: [],
    node: []
  },
  mutations: {
    resize(state, { x, y }) {
      state.resolution.set(x, y);
      state.isMobile = x < 768;
      state.isLandscape = x > y;
    },
    toggleMadoriMode(state) {
      if (state.madoriMode === "2d") {
        state.madoriMode = "3d";
      } else if (state.madoriMode === "3d") {
        state.madoriMode = "2d";
      }
    },
    setId(state, id) {
      state.id = id;
    },
    setCategory(state, category) {
      state.category = category;
    },
    setRooms(state) {
      state.rooms = {};
    },
    setRoomTexIndex(state, vals) {
      if (vals.type === "wall") {
        state.rooms[vals.key].wallTexIndex = vals.index;
      } else if (vals.type === "floor") {
        state.rooms[vals.key].floorTexIndex = vals.index;
      }
    },
    setNameOfRoom(state, val) {
      state.nameOfRoom = val !== undefined ? val : "不明";
    },
    setTestMode(state, val) {
      state.testMode = val;
    },
    setPhotos(state, vals) {
      state.photos = vals;
    },
    setNode(state, vals) {
      state.node = vals;
    },
    setInformation(state, vals) {
      state.information = vals;
    },
    toggleIsFullScreen(state) {
      state.isFullScreen = !state.isFullScreen;
    },
    onIsGalleryDrawerMenu(state) {
      state.isGalleryDrawerMenu = true;
    },
    offIsGalleryDrawerMenu(state) {
      state.isGalleryDrawerMenu = false;
    },
    setImgEx(state, vals) {
      state.imgEx = vals;
    },
    toggleIsGalleryList(state) {
      state.isGalleryList = !state.isGalleryList;
    },
    setIsLoading(state, vals) {
      state.isLoading = vals;
    },
    setIsCursorPointer(state, vals) {
      state.isCursorPointer = vals;
    },
    setCurrentNodeId(state, vals) {
      state.currentNodeId = vals;
    }
  },
  actions: {},
  modules: {
    touch,
    modal,
    webgl,
    errorModal
  }
});
